import React from "react";

function IconWarning(props) {
  return (
    <div className={props.className}>
        <svg
            height={props.height}
            xmlns="http://www.w3.org/2000/svg"
            fillRule="evenodd"
            strokeLinejoin="round"
            strokeMiterlimit="2"
            clipRule="evenodd"
            viewBox="0 0 199 179"
        >
        <path
            className={props.pathClass ? props.pathClass : "g1-fill"}
            d="M9042.2 1500.26c4.27 7.39 4.27 16.5 0 23.89a23.87 23.87 0 01-20.68 11.94H8870.6a23.87 23.87 0 01-20.68-11.94 23.878 23.878 0 010-23.89c21.26-36.83 54.19-93.86 75.46-130.7a23.87 23.87 0 0120.68-11.94c8.53 0 16.42 4.55 20.68 11.94 21.27 36.84 54.2 93.87 75.46 130.7zm-12.63 7.3a9.258 9.258 0 010 9.3 9.31 9.31 0 01-8.05 4.65H8870.6a9.31 9.31 0 01-8.05-4.65 9.306 9.306 0 010-9.3c21.26-36.84 54.19-93.87 75.46-130.7a9.29 9.29 0 018.05-4.65 9.29 9.29 0 018.05 4.65l75.46 130.7zm-83.51-25.01c5.27 0 9.55 4.28 9.55 9.55 0 5.27-4.28 9.55-9.55 9.55-5.27 0-9.55-4.28-9.55-9.55 0-5.27 4.28-9.55 9.55-9.55zm-5.83-69.23c-1.66 0-3.24.69-4.35 1.92a5.837 5.837 0 00-1.51 4.51c1.34 14.45 4.59 36.89 5.87 50.64.3 3.24 3.02 5.72 6.27 5.72 3.3 0 6.04-2.53 6.31-5.82 1.1-13.85 3.88-36.25 5.02-50.62a5.81 5.81 0 00-1.54-4.46 5.858 5.858 0 00-4.32-1.89h-11.75z"
            transform="translate(-8846.72 -1357.62)"
        ></path>
        </svg>
    </div>
  );
}

export default IconWarning;
